import { FontSize100, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
import { Variants } from "../types.js";
import { costcoInlineSxObj } from "./styles/inline/styles.js";
import { skeletonResponsiveStyles, responsiveStyles } from "./styles/responsiveStyles.js";
import { adobeSxObj } from "./styles/stacked/adobeStyles.js";
import { getBkgCircleStyles, defaultSxObj } from "./styles/stacked/defaultStyles.js";
const getBgOnlyStyles = (imageUrl) => {
  const imageStyles = {
    "@media (prefers-reduced-motion)": {
      transform: "none !important"
    },
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: "cover",
    borderRadius: "100px",
    display: "block",
    margin: "auto",
    transition: "all 0.3s linear",
    ...responsiveStyles
  };
  const titleStyles = {
    fontSize: { md: FontSize300, xs: FontSize100 },
    fontStretch: "100%",
    textAlign: "center",
    wordBreak: "normal"
  };
  return {
    ...defaultSxObj,
    imageStyles,
    titleStyles
  };
};
const getCategoryTileStyles = ({
  variant,
  foreground,
  background,
  categoryData
}) => {
  switch (variant) {
    case Variants.COSTCO_INLINE:
      if (background) {
        return {
          ...costcoInlineSxObj,
          ...getBkgCircleStyles(categoryData == null ? void 0 : categoryData.backgroundColor)
        };
      }
      return { ...costcoInlineSxObj };
    default:
      if (foreground && !background) {
        return { ...adobeSxObj };
      } else if (foreground && background) {
        return {
          ...defaultSxObj,
          ...getBkgCircleStyles(categoryData == null ? void 0 : categoryData.backgroundColor)
        };
      } else {
        return { ...getBgOnlyStyles(categoryData.imageUrl) };
      }
  }
};
const getSkeletonStyle = (variant) => {
  let responsiveStylesObj;
  if (variant === Variants.STACKED) {
    responsiveStylesObj = {
      direction: "column",
      sxPrimary: {
        borderRadius: "100%",
        ...responsiveStyles
      }
    };
  } else {
    responsiveStylesObj = {
      direction: "row",
      sxPrimary: {
        borderRadius: "8px",
        ...responsiveStyles
      }
    };
  }
  return {
    ...responsiveStylesObj,
    sxSecondary: {
      ...skeletonResponsiveStyles
    }
  };
};
const isCategoryTileUIProps = (props) => {
  if (props && Object.prototype.hasOwnProperty.call(props, "categoryData")) {
    return true;
  }
  return false;
};
export {
  getBgOnlyStyles,
  getCategoryTileStyles,
  getSkeletonStyle,
  isCategoryTileUIProps
};
